import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardSection from './sections/DashboardSection';
import DegreesSection from './sections/DegreesSection';
import TSUSection from './sections/TSUSection';
import MasterDegreesSection from './sections/MasterDegreesSection';
import SpecialitiesSection from './sections/SpecialitiesSection';
import BachilleratoSection from './sections/BachilleratoSection';
import PromotionsSection from './sections/PromotionsSection';
import EventsSection from './sections/EventsSection';
import TwilioConfigSection from './sections/TwilioConfigSection';
import WhatsappSection from './sections/WhatsappSection';
import AcademicCyclesSection from './sections/AcademicCyclesSection';
import styles from './AdminPage.module.css';

function AdminPage() {
  const navigate = useNavigate();
  const [section, setSection] = useState('dashboard');
  const [configOpen, setConfigOpen] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('odm_token');
    localStorage.removeItem('odm_user_id');
    localStorage.removeItem('odm_role');
    navigate('/portal');
  };

  return (
    <div className={styles.page}>
      {/* ── Header ── */}
      <header className={styles.header}>
        <img src="/logos/logos_4.png" alt="ODM" className={styles.headerLogo} />
        <span className={styles.headerTitle}>Panel de administración</span>
        <button type="button" className={styles.logoutBtn} onClick={handleLogout}>
          Cerrar sesión
        </button>
      </header>

      <div className={styles.layout}>
        {/* ── Sidebar ── */}
        <aside className={styles.sidebar}>
          <button
            type="button"
            className={`${styles.navItem} ${section === 'dashboard' ? styles.navItemActive : ''}`}
            onClick={() => setSection('dashboard')}
          >
            Dashboard
          </button>

          <button
            type="button"
            className={`${styles.navItem} ${section === 'events' ? styles.navItemActive : ''}`}
            onClick={() => setSection('events')}
          >
            Eventos
          </button>

          <button
            type="button"
            className={`${styles.navItem} ${section === 'promotions' ? styles.navItemActive : ''}`}
            onClick={() => setSection('promotions')}
          >
            Promociones
          </button>

          <button type="button" className={`${styles.navItem} ${section === 'whatsapp' ? styles.navItemActive : ''}`} onClick={() => setSection('whatsapp')}>
            WhatsApp
          </button>

          <div className={styles.navGroup}>
            <button
              type="button"
              className={styles.navGroupTitle}
              onClick={() => setConfigOpen((o) => !o)}
            >
              <span>Configuración</span>
              <span className={`${styles.chevron} ${configOpen ? styles.chevronOpen : ''}`}>›</span>
            </button>
            {configOpen && (
              <div className={styles.navGroupItems}>
                <button type="button" className={`${styles.navSubItem} ${section === 'degrees' ? styles.navItemActive : ''}`} onClick={() => setSection('degrees')}>
                  Licenciaturas
                </button>
                <button type="button" className={`${styles.navSubItem} ${section === 'tsu' ? styles.navItemActive : ''}`} onClick={() => setSection('tsu')}>
                  TSU
                </button>
                <button type="button" className={`${styles.navSubItem} ${section === 'masters' ? styles.navItemActive : ''}`} onClick={() => setSection('masters')}>
                  Maestrías
                </button>
                <button type="button" className={`${styles.navSubItem} ${section === 'specialities' ? styles.navItemActive : ''}`} onClick={() => setSection('specialities')}>
                  Especialidades
                </button>
                <button type="button" className={`${styles.navSubItem} ${section === 'bachillerato' ? styles.navItemActive : ''}`} onClick={() => setSection('bachillerato')}>
                  Bachillerato
                </button>
                <button type="button" className={`${styles.navSubItem} ${section === 'twilio-config' ? styles.navItemActive : ''}`} onClick={() => setSection('twilio-config')}>
                  Twilio config
                </button>
                <button type="button" className={`${styles.navSubItem} ${section === 'academic-cycles' ? styles.navItemActive : ''}`} onClick={() => setSection('academic-cycles')}>
                  Ciclos escolares
                </button>
              </div>
            )}
          </div>
        </aside>

        {/* ── Main ── */}
        <main className={styles.main}>
          {section === 'dashboard' && <DashboardSection />}
          {section === 'whatsapp' && <WhatsappSection />}
          {section === 'promotions' && <PromotionsSection />}
          {section === 'events' && <EventsSection />}
          {section === 'degrees' && <DegreesSection />}
          {section === 'tsu' && <TSUSection />}
          {section === 'masters' && <MasterDegreesSection />}
          {section === 'specialities' && <SpecialitiesSection />}
          {section === 'bachillerato' && <BachilleratoSection />}
          {section === 'twilio-config' && <TwilioConfigSection />}
          {section === 'academic-cycles' && <AcademicCyclesSection />}
        </main>
      </div>
    </div>
  );
}

export default AdminPage;
